import React from 'react';
import WorkspaceContainer from '../components/workspace.container';

/**
 * The app's home screen: everything you do with an audio file, on one page.
 *
 * Replaces the separate Transcribe and Convert pages, which were two halves of a single job the
 * user had to walk between. Both URLs now redirect here.
 */
const WorkspacePage: React.FC = () => <WorkspaceContainer />;

export default WorkspacePage;
